export type FormatAddressData = Partial<{
  name: string | null | undefined
  company: string | null | undefined
  line1: string | null | undefined
  line2: string | null | undefined
  city: string | null | undefined
  state: string | null | undefined

  country: string | null | undefined
  phone: string | null | undefined

  // Postal code
  zip: string | null | undefined
  postal: string | null | undefined

  // Smarty fields
  deliveryLine1: string
  streetName: string
  cityName: string
  stateAbbreviation: string
  zipcode: string
  isResidential: boolean | null
}>

export function formatAddress(
  address: FormatAddressData,
  size: 'xs' | 'sm' | 'md' | 'lg' | 'xl' = 'md',
): string {
  const city = address.city || address.cityName
  const company = address.company
  const country = address.country
  const phone = address.phone
  const state = address.state || address.stateAbbreviation
  const line1 = address.line1 || address.deliveryLine1
  // Per USPS spec: deliveryLine1 already includes secondary (apt/suite), so only use line2 if explicitly set
  const line2 = address.line2 || undefined
  const name = address.name
  const zip = address.postal || address.zip || address.zipcode

  let firstRow = ''
  let secondRow = ''
  let thirdRow = ''
  let fourthRow = ''
  let fifthRow = ''

  if (size === 'xs') {
    firstRow = [line1, line2, city, state, zip, country].filter(Boolean).join(', ')
  }

  if (size === 'sm') {
    firstRow = [line1, line2].filter(Boolean).join(', ')
    secondRow = [city, state, zip, country].filter(Boolean).join(', ')
  }

  if (size === 'md') {
    firstRow = company || name || ''
    secondRow = [line1, line2].filter(Boolean).join(', ')
    thirdRow = [city, state, zip].filter(Boolean).join(', ')
    fourthRow = [country, phone].filter(Boolean).join(', ')
  }

  if (size === 'lg') {
    firstRow = company || name || ''
    secondRow = [line1, line2].filter(Boolean).join(', ')
    thirdRow = [city, state, zip].filter(Boolean).join(', ')
    fourthRow = [country, phone].filter(Boolean).join(', ')
    fifthRow = ''
  }

  return [firstRow, secondRow, thirdRow, fourthRow, fifthRow].filter(Boolean).join('\n')
}
